import { ANALYTICS_ENABLED } from '../../config/analyticsConfig'

export const NAVIGATOR_ANALYTICS_EVENTS = [
  'regulatory_page_view',
  'regulatory_search',
  'regulatory_filter_applied',
  'regulatory_record_open',
  'official_source_click',
  'timeline_event_open',
  'deadline_filter_applied',
  'applicability_wizard_start',
  'applicability_wizard_complete',
  'checklist_generated',
  'checklist_downloaded',
  'lead_form_view',
  'lead_form_success',
  'demo_cta_click',
] as const

export type NavigatorAnalyticsEvent = (typeof NAVIGATOR_ANALYTICS_EVENTS)[number]

/** Consent-aware tracking. Never send profile answers, raw search text, or contact details. */
export function trackNavigatorEvent(
  event: NavigatorAnalyticsEvent,
  props?: Record<string, string | number | boolean>,
): void {
  if (!ANALYTICS_ENABLED || typeof window === 'undefined') return
  try {
    const safe: Record<string, string | number | boolean> = {}
    for (const [key, value] of Object.entries(props || {})) {
      if (key === 'search' || key === 'email' || key === 'company' || key === 'profile') continue
      safe[key] = value
    }
    const w = window as Window & { gtag?: (...args: unknown[]) => void; dataLayer?: unknown[] }
    if (typeof w.gtag === 'function') {
      w.gtag('event', event, safe)
      return
    }
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({ event, ...safe })
  } catch {
    // Analytics must not break the navigator.
  }
}
